// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xLoadingOverlay } from "@ces/App/Handlers/XNG/Common";
import { FulfillmentMethod } from "@ces/XDL/types";
import isApiError from "@insite/client-framework/Common/isApiError";
import { addToEndOfChain, addToStartOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateAccount } from "@insite/client-framework/Services/AccountService";
import {
    CallUpdateAccount,
    chain,
    GetCurrentAccount,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SaveCurrentAccount";

type HandlerType = typeof GetCurrentAccount;

export const XPopulateApiParameter: typeof PopulateApiParameter = props => {
    // Add pickUpType
    const currentDefault = props.account.defaultFulfillmentMethod;
    props.apiParameter = {
        account: {
            ...props.account,
            defaultFulfillmentMethod:
                currentDefault !== FulfillmentMethod.Ship ? FulfillmentMethod.Pickup : FulfillmentMethod.Ship,
            properties: {
                ...(props.account.properties || {}),
                ...(currentDefault !== FulfillmentMethod.Ship && { pickUpType: currentDefault }),
            },
        },
    };
};

export const XCallUpdateAccount: HandlerType = async props => {
    try {
        props.apiResult = await updateAccount(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            // XNG-Changes : Clear loading overlay when error is returned
            props.dispatch(xLoadingOverlay({ key: "clear", value: "save_current_account" }));
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const setIsLoading: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", value: "save_current_account" }));
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "remove", value: "save_current_account" }));
};

addToStartOfChain(chain, setIsLoading);
replaceInChain(chain, PopulateApiParameter, XPopulateApiParameter);
replaceInChain(chain, CallUpdateAccount, XCallUpdateAccount);
addToEndOfChain(chain, setLoadingCompleted);
